/**
 * 地图画板编排入口（对外 API 不变，供 MapDrawingBoardView）
 * 组合：
 * - useMapDrawingLayers：图层 / 测距标注 / 文字 Marker / 草稿预览
 * - useMapDrawingSelection：选中 / 编辑定型 / 样式回写
 * - useMapDrawingPointer：命中检测 / 键盘删除 / 地图事件
 * - useMapDrawingEdit：定型完成、工具切换、清空，并编排上述 hooks（内调 history + export + tools）
 */
import useMapDrawingEdit from './useMapDrawingEdit';

export default function useMapDrawingBoard(props) {
  return useMapDrawingEdit(props);
}
